import { Coord } from '@shared/interfaces/map.interface';

const EARTH_RADIUS_METERS = 6371000;
//* 같은 장소도 검색 출처에 따라 좌표 끝자리가 달라지므로 이 안쪽은 이동으로 치지 않는다
const SAME_LOCATION_METERS = 10;

//* 빈 문자열·0·숫자가 아닌 값은 지도에 엉뚱한 곳(바다 한가운데)을 그리므로 좌표로 치지 않는다
const isCoordNumber = (value?: string) => Boolean(Number(value));

export const hasCoordValue = (coord?: Coord | null): coord is Coord =>
  isCoordNumber(coord?.x) && isCoordNumber(coord?.y);

const getDistanceMeters = (from: Coord, to: Coord) => {
  const toRadian = (degree: number) => (degree * Math.PI) / 180;
  const fromLat = toRadian(Number(from.y));
  const toLat = toRadian(Number(to.y));
  const deltaLat = toLat - fromLat;
  const deltaLng = toRadian(Number(to.x) - Number(from.x));
  const haversine =
    Math.sin(deltaLat / 2) ** 2 +
    Math.cos(fromLat) * Math.cos(toLat) * Math.sin(deltaLng / 2) ** 2;
  return 2 * EARTH_RADIUS_METERS * Math.asin(Math.sqrt(haversine));
};

//* 지도는 각자 핀을 가운데 두고 그려서 가까운 이동은 눈으로 구분되지 않는다 → 거리를 글로 함께 보여준다
export const formatCoordMove = (from?: Coord | null, to?: Coord | null) => {
  if (!hasCoordValue(to)) {
    return hasCoordValue(from) ? '새 좌표 없음 · 기존 위치 유지' : '좌표 없음';
  }
  if (!hasCoordValue(from)) return '좌표 새로 지정';
  const meters = getDistanceMeters(from, to);
  if (meters < SAME_LOCATION_METERS) return '지도 위치 동일';
  if (meters < 1000) return `위치 약 ${Math.round(meters / 10) * 10}m 이동`;
  return `위치 약 ${(meters / 1000).toFixed(1)}km 이동`;
};

//* 저장 후 refetch로 기존값이 새 값과 같아지면 변경 전/후 비교를 접기 위한 판정
export const isAddressChanged = (
  savedAddress: string | undefined,
  savedCoord: Coord | undefined | null,
  selected: { address: string; coord?: Coord } | null,
  keepSavedCoord = false,
) => {
  if (!selected) return false;
  if (selected.address !== savedAddress) return true;
  if (keepSavedCoord || !hasCoordValue(selected.coord)) return false;
  return (
    String(selected.coord.x) !== String(savedCoord?.x) ||
    String(selected.coord.y) !== String(savedCoord?.y)
  );
};
